import * as React from 'react'

import {
  type Colors,
  Icon,
  type MediumIcon,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'

interface Props {
  information: string | React.ReactNode
  icon?: MediumIcon
  color?: Colors
}

const ContractTooltip = ({ information, color = 'grey800', icon = 'info-circle-line' }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Alt attachment="bottom center" open={open} toggle={toggle} label={information}>
      <Icon.Medium icon={icon} color={color} />
    </Tooltip.Alt>
  )
}

export default ContractTooltip
